import StatefulArray from 'ember-data-model-fragments/array/stateful';

// ember-data-model-fragments' StatefulArray is `EmberObject.extend(MutableArray)`
// — it has `slice()`/`toArray()` but no `Symbol.iterator`. So `[...frags]`,
// `for...of`, `Array.from(frags)` and destructuring all throw
// "X is not iterable", which is easy to hit by accident because every other
// array-ish thing in the app (RecordArray, ManyArray, A()) *is* iterable.
//
// FragmentArray extends StatefulArray, so patching the base covers both.
//
// TEMPORARY: delete this initializer (and its app/ re-export) once fragments
// are gone — WarpDrive's collections are native-array based and iterable. The
// `todo` in tests/unit/initializers/fragment-array-iterable-test.js reports the
// moment upstream ships this, so CI tells you when it is safe to remove.
export function initialize() {
  if (!StatefulArray.prototype[Symbol.iterator]) {
    StatefulArray.prototype[Symbol.iterator] = function () {
      // `toArray` is the EmberArray method on StatefulArray itself, and it is
      // the only way to read this thing before it is iterable — which is the
      // very gap being filled. Not a plain array, so the ban does not apply.
      // eslint-disable-next-line no-restricted-properties
      return this.toArray()[Symbol.iterator]();
    };
  }
}

export default {
  name: 'fragment-array-iterable',
  initialize,
};
